import React from 'react';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import Switch, { SwitchClassKey } from '@material-ui/core/Switch';

export interface CustomSwitchProps {
  id: string;
  classes?: Partial<ClassNameMap<SwitchClassKey>>;
  checked: boolean;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  id,
  checked,
  classes,
  handleChange,
}) => {
  return (
    <Switch
      id={id}
      classes={classes}
      size="small"
      onChange={handleChange}
      checked={checked}
    />
  );
};

export default CustomSwitch;
